import React from 'react';

interface TokenCounterProps {
  tokens: number;
}

export const TokenCounter: React.FC<TokenCounterProps> = ({ tokens }) => {
  const getTokenColor = (count: number) => {
    if (count < 1000) return 'text-ghost-400';
    if (count < 2000) return 'text-amber-400';
    if (count < 4000) return 'text-orange-400';
    return 'text-red-400';
  };

  const formatTokens = (count: number) => {
    if (count < 1000) return count.toString();
    if (count < 10000) return `${(count / 1000).toFixed(1)}k`;
    return `${Math.round(count / 1000)}k`;
  };

  return (
    <div className="flex items-center space-x-2">
      <div className={`text-xs font-mono ${getTokenColor(tokens)}`}>
        {formatTokens(tokens)} tokens
      </div>
      {tokens > 2000 && (
        <div className="w-1 h-1 rounded-full bg-amber-400 animate-pulse" />
      )}
    </div>
  );
};